import type { ReactNode } from 'react';

import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

type BadgeTone = 'priceDrop' | 'new' | 'neutral';

const BADGE_TONE_CLASSES: Record<BadgeTone, string> = {
  priceDrop:
    'text-[#3c2b05] [background:linear-gradient(90deg,#f9f5cb,#f5efa1)_border-box_padding-box,linear-gradient(-144.91deg,rgb(60_43_5/30%)_5.54%,transparent_16.56%)_border-box,linear-gradient(144.91deg,rgb(60_43_5/30%)_-4.08%,transparent_30.52%)_border-box,linear-gradient(#cecc5f,#cecc5f)_border-box]',
  new: 'text-[#020e60] [background:linear-gradient(90deg,#e9f1fa,#cde4ff)_border-box_padding-box,linear-gradient(29.69deg,rgb(249_252_255/50%)_8.39%,transparent_26.48%)_border-box,linear-gradient(-172.07deg,rgb(249_252_255/40%)_17.64%,transparent_43.92%)_border-box,linear-gradient(#63a5f8,#63a5f8)_border-box]',
  neutral:
    'text-[#3c3733] [background:linear-gradient(90deg,#eae8e0,#d7d4cd)_border-box_padding-box,linear-gradient(27.77deg,rgb(249_248_245/60%)_8.46%,transparent_26.47%)_border-box,linear-gradient(-172.67deg,rgb(249_248_245/70%)_17.64%,transparent_43.76%)_border-box,linear-gradient(#bdbab3,#bdbab3)_border-box]',
};

export const PdpStatusBadge = ({
  label,
  tone,
  icon,
}: {
  label: string;
  tone: BadgeTone;
  icon?: ReactNode;
}) => (
  <Text
    as="span"
    className={cn(
      'inline-flex h-7 w-max shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-transparent px-2.25 text-label-xs leading-none tracking-[-0.03em]',
      BADGE_TONE_CLASSES[tone],
    )}
  >
    {icon}
    {label}
  </Text>
);
